import React, { useEffect, useState } from "react";

import { useSelector, useDispatch } from "react-redux";

import { useNavigate } from "react-router-dom";

// Import supabase configuration
import supabase from "../../config/supabase";

// import { Grid,Paper, TextField, Button } from '@material-ui/core'
import { Grid, Paper, TextField, InputBase, Button, InputLabel } from "@mui/material";
import { makeStyles } from "@material-ui/core/styles";
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';
import Box from "@mui/material/Box";
import OutlinedInput from '@mui/material/OutlinedInput';
import FormControl from '@mui/material/FormControl';
import { Buffer } from "buffer";
import { loginUser, signupUser } from "../../redux/actions/actions";
import { borderRadius } from "@mui/system";
import mixpanel from 'mixpanel-browser';


const Login = (props) => {

  const [values, setValues] = React.useState({
    password: '',
    email: '',
    showPassword: false,
  });
  const [errorMessage, setErrorMessage] = useState("");
  const { currentUser } = useSelector((state) => state.user);
  
  const dispatch = useDispatch();
  const navigate = useNavigate();
  
  
  const btnstyle = { margin: `${!errorMessage ? "20px 0 0 0" : ''}`, backgroundColor: "#0F69F6", fontSize: "16px", width: "48%", borderRadius: "4px", textTransform : 'none',};
  const loginbtnstyle = { margin: `${!errorMessage ? "20px 0 0 0" : ''}`, backgroundColor: "#0F69F6", fontSize: "16px", height: '41px', borderRadius: "4px", textTransform : 'none',};
  const Secondbtnstyle = { margin: `${!errorMessage ? "20px 0 0 0" : ''}`, backgroundColor: "#FF4974", fontSize: "16px", width: "48%", borderRadius: "4px", textTransform : 'none',};
  
  const imgStyle = { margin: "10px auto", width: "8em", height: "1.5em" };
  
  
  const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 1,
    borderRadius: '4.27px',
    [`&.${linearProgressClasses.colorPrimary}`]: {
      backgroundColor: theme.palette.grey[theme.palette.mode === 'light' ? 300 : 800],
    },
    [`& .${linearProgressClasses.bar}`]: {
      borderRadius: 5,
      backgroundColor: theme.palette.mode === 'light' ? values.password.length <= 3 && values.password.length > 0 ?'#FF1744' : values.password.length >= 3 && values.password.length < 6 ? '#FFCA28' : values.password.length >= 6 && values.password.length < 8 ? '#64DD17' : values.password.length >= 6 ? '#00C853' : '#E0E0E0' : '#308fe8',
    },
  }));

  const handleSubmit = async(e) => {
    e.preventDefault();
    mixpanel.init('de405b9420bcdeddec4d225dc80801ec'); 
    var { data, error } = await supabase
    .from("board_clients_invitation")
    .select("*")
    .match({ url_with_token: window.location.href, email: values.email || props.clientEmail});

    if(!props.isLogin){
      if(values.password.length >= 6){
      dispatch(signupUser(props.clientEmail, values.password))
      .then(() => {
        mixpanel.track('Signed up',{
          'email':  values.email,
        });
        mixpanel.identify(data[0].id);
        mixpanel.people.set({
          $email: values.email,
          $name: values.email,
        });
        localStorage.setItem("loggedIn", true);
        localStorage.removeItem("needLogin");
        sessionStorage.removeItem("publicInfo");
        props.handleCloseModal();
        props.justView();
        props.showLogin();
        setValues({
          password: '',
          email: '',
          showPassword: false,
        });

        if(props.reqestInterview){
          localStorage.setItem("clientBoardProfile", props.profileId);
          props.isPublic ? navigate(`/interviewSchedule?board=${Buffer.from(props.boardId, "utf-8").toString("base64")}`) 
          :navigate(`/interviewSchedule?client=${Buffer.from(props.clientInvitationId, "utf-8").toString("base64")}`);
        }
      })
      .catch(() => {
        setErrorMessage("User already exist");
        console.log("Error");
      });
    } else {
      setErrorMessage("Enter 6 digit password");
    }
    } 
    else {
        if(data && data.length){
          dispatch(loginUser(values.email, values.password))
          .then(() => {
            mixpanel.track('Logged in',{
              'email':  values.email,
            });
            mixpanel.identify(data[0].id);
            mixpanel.people.set({
              $email: values.email,
              $name: values.email,
            });
            localStorage.setItem("loggedIn", true);
            localStorage.removeItem("needLogin");
            sessionStorage.removeItem("publicInfo");
            props.handleCloseModal();
            props.justView();
            props.showLogin();
            
            setValues({
              password: '',
              email: '',
              showPassword: false,
            });

            let dash_id = Buffer.from(data[0].dashboard_id, "utf-8").toString("base64");
            let link = "dashboard=" + dash_id;
            localStorage.setItem("dashboard", link);

            if(props.reqestInterview){
              localStorage.setItem("clientBoardProfile", props.profileId);
              // For public candidate
              if(props.isPublic){
                  navigate(`/interviewSchedule?board=${Buffer.from(props.boardId, "utf-8").toString("base64")}`) 
              }
              // For priavte candidate
              else{
                // If selected candidate is already scheduled
                if(data[0].profiles.some(p => p.id == props.profileId && p.meetingTime)){
                  console.log("Do nothing")
                }
                // No agenda available
                else if(!data[0].profiles.some(p => p.meetingTime)){
                  navigate(`/interviewSchedule?client=${Buffer.from(props.clientInvitationId, "utf-8").toString("base64")}`);
                }
                // If selected candidate is not scheduled and a agenda is available
                else{
                  navigate(`/addMeeting?client=${Buffer.from(props.clientInvitationId, "utf-8").toString("base64")}`)
                }
              }
            }

          })
          .catch(() => {
            setErrorMessage("Invalid email or password");
            console.log("Error");
          });
        }
        else{
          setErrorMessage("You do not have access to this board");
        }
    }
  };


  const handleClickShowPassword = (e) => {
    setValues({
      ...values,
      showPassword: !values.showPassword,
    });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleChange = (prop) => (event) => {
    setValues({ ...values, [prop]: event.target.value });
  };

  const handleNotNowClick = () => {
    mixpanel.track('Skip',{
      'email':  values.email,
    });
    localStorage.setItem("loggedIn", false);
    setValues({
      password: '',
      email: '',
      showPassword: false,
    });
    props.handleCloseModal();
    if(props.reqestInterview && !(props.sessionDetails.length > 0)){
      localStorage.setItem("clientBoardProfile", props.profileId);
      props.isPublic ? navigate(`/interviewSchedule?board=${Buffer.from(props.boardId, "utf-8").toString("base64")}`) 
      :navigate(`/interviewSchedule?client=${Buffer.from(props.clientInvitationId, "utf-8").toString("base64")}`);
    }
  }

  return (
        <div className="flex justify-center">
          <Grid
            container
            direction="column"
            justifyContent="space-between"
            alignItems="center"
            style={{ marginTop: "12px", backgroundColor: '#232428', padding: "40px 20px 20px 20px", borderRadius: '4.27px'}}
          >
              <Grid align="center">
                <h1 className="text-[#969696] text-xs 1xl:text-base">{props.isLogin ? "WELCOME BACK" : "Setup your password for"}</h1>
                <h1 className="text-[#FFFFFF] font-semibold text-lg xl-2:text-1xl">{props.isLogin ? "Log into your account" : props.clientEmail}{}</h1>
              </Grid>
                { !props.isLogin ?
                  <form className="w-11/12 1xl:mt-2 text-center" onSubmit={handleSubmit}>
                  <div className="mb-8">
                    <input 
                    type="password" 
                    name="password" 
                    id="password" 
                    placeholder="Create a strong password"
                    onClick={() => setErrorMessage("")}
                    onChange={handleChange('password')}
                    className={`bg-[#232428] text-[#FFFFFF] w-full focus:outline-none text-[16px] text-center mt-10  pb-2`}
                    />
                    <Box sx={{ flexGrow: 1, marginTop: '-23px' }}>
                      <br />
                      <BorderLinearProgress variant="determinate" value={values.password.length <= 3 && values.password.length > 0 ? 25 : values.password.length >= 3 && values.password.length < 6 ? 50 : values.password.length >= 6 && values.password.length < 8 ? 75 : values.password.length >= 8 ? 100 : 0} />
                    </Box>
                    <div className="flex justify-between mt-1">
                      {values.password.length > 0 && 
                        <>
                          <div className="text-[10px] text-[#FFFFFF]">
                            {values.password.length <= 3 && values.password.length > 0 ? (
                            <div className="flex">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="12" height="12" className="mt-0.5"><path fill="none" d="M0 0h24v24H0z"/><path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm-1-5h2v2h-2v-2zm0-8h2v6h-2V7z" fill="rgba(231,76,60,1)"/></svg><span className="ml-1 text-left">Your password should be at least 6-8 characters long</span>
                            </div>)
                            : values.password.length >= 3 && values.password.length < 6 ? 'Use numbers to make it stronger' : values.password.length >= 6 && values.password.length < 8 ? 'Use both uppercase and lowercase letters' : values.password.length >= 8 ? 'Good job! Your password looks strong.' : ''}
                          </div>  
                          <div className={`${values.password.length <= 3 && values.password.length > 0 ?'text-[#FF1744]' : values.password.length >= 3 && values.password.length < 6 ? 'text-[#FFCA28]' : values.password.length >= 6 && values.password.length < 8 ? 'text-[#64DD17]' : values.password.length >= 8 ? 'text-[#00C853]' : 'text-[#E0E0E0]'} text-xs`}>
                            {values.password.length <= 3 && values.password.length > 0 ?'Weak' : values.password.length >= 3 && values.password.length < 6 ? 'Fair' : values.password.length >= 6 && values.password.length < 8 ? 'Good' : values.password.length >= 8 ? 'Strong' : ''}
                          </div>  
                        </>
                      }
                    </div>
                  </div>

                  {errorMessage && (
                    <div className="my-2 flex text-right text-red-1 col-span-12">{errorMessage}</div>
                  )}
                  <div className="flex justify-between mb-5">
                  <Button
                      type="button"
                      variant="contained"
                      size="medium"
                      style={Secondbtnstyle}
                      onClick={handleNotNowClick}
                      fullWidth
                      >
                      Skip
                    </Button>
                    
                    <Button
                      type="submit"
                      variant="contained"
                      size="medium"
                      style={btnstyle}
                      fullWidth
                      >
                      Set now
                    </Button>
                  </div>
                  </form>
                  :
                  <form className="w-full mt-5" onSubmit={handleSubmit}>
                    <div>
                      <div>
                      </div>
                      <InputBase
                        variant="standard"
                        type='text'
                        value={values.email}
                        placeholder="Enter your email"
                        onChange={handleChange('email')}
                        style={{color: "#FFFFFF",
                        borderBottom: "0.2px solid #FFFFFF",
                        position: 'relative',
                        borderRadius: 1.65,
                        height: '35px',
                        marginTop: '15px',
                        marginBottom: '20px',
                        fontSize: 16,
                        padding: '10px 18px',
                      }}
                      fullWidth
                      onClick={() => setErrorMessage("")}
                      required
                      />
                      <div>
                      </div>
                      <InputBase
                        variant="standard"
                        type={values.showPassword ? 'text' : 'password'}
                        value={values.password}
                        placeholder="Enter your Password"
                        onChange={handleChange('password')}
                        style={{color: "#FFFFFF",
                        borderBottom: "0.2px solid #FFFFFF",
                        position: 'relative',
                        borderRadius: 1.65,
                        height: '35px',
                        marginTop: '10px',
                        marginBottom: '15px',
                        fontSize: 16,
                        padding: '10px 18px',
                      }}
                      fullWidth
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              style={{color: '#474747', }}
                              aria-label="toggle password visibility"
                              onClick={handleClickShowPassword}
                              onMouseDown={handleMouseDownPassword}
                              edge="end"
                            >
                              {values.showPassword ? <VisibilityOff style={{width: '20px'}} /> : <Visibility style={{width: '20px' }} />}
                            </IconButton>
                          </InputAdornment>
                        }
                        label="Password"
                        onClick={() => setErrorMessage("")}
                        required
                      />
                    </div>
                  {errorMessage && (
                    <div className="my-2 flex text-right text-sm text-red-1 col-span-12">{errorMessage}</div>
                    )}
                  <div className="flex justify-between mb-5">
                    <Button
                        type="button"
                        variant="contained"
                        size="medium"
                        style={Secondbtnstyle}
                        onClick={handleNotNowClick}
                        fullWidth
                        >
                        Skip
                    </Button>

                    <Button
                      type="submit"
                      variant="contained"
                      size="medium"
                      style={btnstyle}
                      fullWidth
                      >
                      Log In
                    </Button>
                  </div>
                  <div className="flex justify-between text-sm font-normal 1xl:text-base text-[#FFFFFF] mt-5 mb-3">
                      <div className="">Not registered yet? <span className="text-blue-1 font-normal cursor-pointer" onClick={() => {
                        setValues({
                          password: '',
                          email: '',
                          showPassword: false,
                        });
                        props.isSignUp();
                      }}>Register now</span></div>
                  </div>
                  </form>
                }
          </Grid>
        </div>
  );
};

export default Login;
